import { useEffect, useState } from 'react';
import Modal from 'react-modal';

import { Box } from '@mui/material';
import Form from '../../../form';

const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    minWidth: '40vw',
    marginRight: '-50%',
    display: 'flex',
    transform: 'translate(-50%, -50%)',
    overflow: 'auto',
    maxHeight: '90vh',
    // marginBottom: 100
  },
};

Modal.setAppElement(document.getElementById('root') as string | HTMLElement)


const toastDuration = 3000;



export default function CopyModal({ isOpen, setIsOpen, entityName, idProp, tableConfigs, onRequestClose, postEntity, form} : any) {

  useEffect(()=>{
    console.log("Formstate is: ", form.state);
  },[])

  const [editable, setEditable] = useState(false);


  const buildGetterFunction = (tc : any) => {
    if(tc.options?.triggeredGetter && form.state[tc.options?.triggerParam]) {
      return ()=> tc.options.triggeredGetter(form.state[tc.options.triggerParam])
    }
    return tc.options?.getter;
  }



  return (<Modal
    isOpen={isOpen}
    onAfterOpen={() => setEditable(true)}
    onRequestClose={() => onRequestClose(form.state)}
    style={{ ...customStyles }}
  >
    {form.state ?

      (<Box style={{margin: 30, width: '100%'}}>
        <Form
         form={form}
        isNewEntity={true}
        submitData={postEntity}
        tableConfigs={tableConfigs}
        buildGetterFunction={buildGetterFunction}
        editable={editable}
        setEditable={setEditable}
        idProp={idProp}
        entityName={entityName}
        setIsOpen={setIsOpen}
        isCopy={true}
    /></Box>)
      : null}
  </Modal>)
}